import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ImperialUnits } from "../../../../components/Math/Units/AllUnits";
import Kilopound from "../../../../components/Math/Units/Imperial/Kilopound";
import KiloNewton from "../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../components/ToolTip";
import { useGetCarryingElementQuery } from "../../../../services/API/titanApi";
import {
  selectFactoredTensionResistance,
  selectResistanceFactor,
  selectedCarryingElement,
  setFactoredTensionResistance,
} from "../../../../store/slices/aashtoSlice";
import { Measurements, selectMeasurementType } from "../../../../store/slices/settingsSlice";

function FactoredTensionResistance() {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const carryingElement = useSelector(selectedCarryingElement);
  const factoredTensionResistanceFormula = `\\displaystyle R_{\\small{TU}} = \\Phi_{\\small{TU}} \\cdot (F_{\\small{y}} \\cdot A_{b})`;

  const resistanceFactor = useSelector(selectResistanceFactor);

  const isMetric = useSelector(selectMeasurementType) == Measurements.METRIC;
  const factoredTensionResistance = useSelector(selectFactoredTensionResistance);

  const { data: carryingElementData } = useGetCarryingElementQuery(carryingElement?.name);

  let fy =
    carryingElementData?.CharacteristicLoadCarryingCapacity / carryingElementData?.CrossSectArea;

  let FIX_VALUE = 87;
  let fyControlling = fy > FIX_VALUE ? FIX_VALUE : fy;

  useEffect(() => {
    let factoredTensionResistance =
      resistanceFactor * fyControlling * carryingElementData?.CrossSectArea;

    dispatch(
      setFactoredTensionResistance({
        value: factoredTensionResistance,
        unit: ImperialUnits.Kilopound,
      })
    );
  }, [carryingElementData?.CrossSectArea, fyControlling, resistanceFactor]);

  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Factored Tension Resistance")}</p>}
      formulaValue={
        <ToolTip
          id={"factoredTensionResistanceFormula"}
          type={IconType.FORMULA}
          formula={factoredTensionResistanceFormula}
        />
      }
      indicesValue={
        <span>
          R<sub>TU</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={factoredTensionResistance.current} decimalScale={2} />
        </span>
      }
      unitValue={isMetric ? <KiloNewton /> : <Kilopound />}
    />
  );
}

export default FactoredTensionResistance;
